import React from 'react';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom';

import { useJourneyTracking } from 'hooks/useJourneyTracking';
import { captureNavOrigin } from 'utils/growlersFlow';

import Home from 'AppRoutes/BeerSubscription';

import Login from 'AppRoutes/Login';
import SignUp from 'AppRoutes/SignUp';
import DashboardLayout from 'components/DashboardLayout';
import Layout from 'components/Layout';

import ScrollToTop from 'components/ScrollToTop';

import DashboardPage from './DashboardPage';

import StoreLayoutPage from './StoreLayoutPage';

import SubscriptionPayment from './SubscriptionPayment';
import SubscriptionPersonalForm from './SubscriptionPersonalForm';
import SubscriptionReview from './SubscriptionReview';
import SubscriptionAccount from './SubscriptionAccount';
import SubscriptionAddress from './SubscriptionAddress';
import SubscriptionShippingOptions from './SubscriptionShippingOptions';
import SubscriptionSuccess from './SubscriptionSuccess';
import ForgotPassword from './ForgotPassword';
import NewDashboardLayout from 'components/NewDashBoardLayout';
import MySubscription from './Dashboard/MySubscription';
import AddAddress from './Dashboard/AddAdress';
import SubscriptionError from './SubscriptionError';
import HopHeadSubscription from 'AppRoutes/HopHeadSubscription';
import BeerTripSubscription from 'AppRoutes/BeerTripSubscription';
import MyAddresses from './Dashboard/MyAddresses';

import BeerStore from './BeerStore';
import BeerStoreShipping from './BeerStoreShipping';
import BeerStorePayment from './BeerStorePayment';
import MyAccount from './Dashboard/MyAccount';
import EditName from './Dashboard/MyAccount/EditName';
import EditPassword from './Dashboard/MyAccount/EditPassword';
import EditPhone from './Dashboard/MyAccount/EditPhone';
import OrderConfirmation from './OrderConfirmation';
import CartDrawer from 'components/CartDrawer';
// import ChatBot from 'components/ChatBot';
import WhatsAppContact from 'components/WhatsAppContact';
import AgeVerificationGate from 'components/AgeVerificationGate';
import Support from './Dashboard/Support';
import MyOrders from './Dashboard/MyOrders';
import BeerStoreError from './BeerStoreError';
import BeerStoreSuccess from './BeerStoreSuccess';
import BeerDetail from './BeerDetail';
import Growlers from './Growlers';
import GrowlerDetail from './GrowlerDetail';
import GrowlerOrderConfirmation from './GrowlerOrderConfirmation';
import GrowlerShipping from './GrowlerShipping';
import GrowlerPayment from './GrowlerPayment';
import GrowlerSuccess from './GrowlerSuccess';
import GrowlerError from './GrowlerError';
import Reviews from './Reviews';
import QuemSomos from './QuemSomos';
import Envelhecidas from './Envelhecidas';
import MailingUnsubscribe from './MailingUnsubscribe';
import PreviousBeers from './PreviousBeers';
import LegalDocument from './LegalDocument';

// import ProtectedRoute from './ProtectedRoute'; // Import the ProtectedRoute HOC
// import RecoveryPassword from './RecoveryPassword';
// import Account from './Account';
// import SignUp from './SignUp';

const JourneyTracking: React.FC = () => {
  useJourneyTracking();
  return null;
};

const NavOriginCapture: React.FC = () => {
  const location = useLocation();
  // Sync capture so Store links in the same render pass already see the origin.
  captureNavOrigin(location.pathname);
  return null;
};

const AppRoutes: React.FC = () => {
  // console.log('Entrou em AppRoutes');
  // const categories = ['Cervejas', 'Copos', 'Camisetas', 'Acessórios'];
  return (
    <Router>
      <AgeVerificationGate>
        <JourneyTracking />
        <NavOriginCapture />
        <ScrollToTop>
        <CartDrawer />
        {/* <ChatBot /> */}
        <WhatsAppContact />
        <Routes>
          {/* <Route path="/login" element={<Login />} /> */}
          <Route
            path="/beer-subscription"
            element={<Navigate to="/" replace />}
          />
          <Route
            path="/hop-head"
            element={
              <Layout>
                <HopHeadSubscription />
              </Layout>
            }
          />
          <Route
            path="/beertrip10anos"
            element={
              <Layout>
                <BeerTripSubscription />
              </Layout>
            }
          />
          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/depoimentos"
            element={
              <Layout>
                <Reviews />
              </Layout>
            }
          />
          <Route
            path="/quem-somos"
            element={
              <Layout>
                <QuemSomos />
              </Layout>
            }
          />
          <Route
            path="/politica-de-privacidade"
            element={
              <Layout>
                <LegalDocument slug="politica-de-privacidade" />
              </Layout>
            }
          />
          <Route
            path="/termos-da-assinatura"
            element={
              <Layout>
                <LegalDocument slug="termos-da-assinatura" />
              </Layout>
            }
          />
          <Route
            path="/termos-de-uso"
            element={
              <Layout>
                <LegalDocument slug="termos-de-uso" />
              </Layout>
            }
          />
          <Route
            path="/envelhecidas"
            element={
              <Layout>
                <Envelhecidas />
              </Layout>
            }
          />
          <Route
            path="/cervejas-anteriores"
            element={
              <Layout>
                <PreviousBeers />
              </Layout>
            }
          />
          <Route
            path="/barricadas"
            element={<Navigate to="/envelhecidas" replace />}
          />
          <Route
            path="/descadastro"
            element={
              <Layout>
                <MailingUnsubscribe />
              </Layout>
            }
          />
          <Route
            path="/signup"
            element={
              <Layout>
                <SignUp />
              </Layout>
            }
          />
          <Route
            path="/login"
            element={
              <Layout>
                <Login />
              </Layout>
            }
          />
          <Route
            path="/subscription"
            element={
              <Layout>
                <SubscriptionReview />
              </Layout>
            }
          />
          <Route
            path="/subscription/account"
            element={
              <Layout>
                <SubscriptionAccount />
              </Layout>
            }
          />
          <Route
            path="/subscription/address"
            element={
              <Layout>
                <SubscriptionAddress />
              </Layout>
            }
          />
          <Route
            path="/subscriptionform"
            element={
              <Layout>
                <SubscriptionPersonalForm />
              </Layout>
            }
          />
          <Route
            path="/shipping"
            element={
              <Layout>
                <SubscriptionShippingOptions />
              </Layout>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <Layout>
                <ForgotPassword />
              </Layout>
            }
          />
          <Route
            path="/payment"
            element={
              <Layout>
                <SubscriptionPayment />
              </Layout>
            }
          />
          <Route
            path="/success"
            element={
              <Layout>
                <SubscriptionSuccess />
              </Layout>
            }
          />
          <Route
            path="/error"
            element={
              <Layout>
                <SubscriptionError />
              </Layout>
            }
          />
          <Route
            path="/beer-store-error"
            element={
              <Layout>
                <BeerStoreError />
              </Layout>
            }
          />
          <Route
            path="/beer-store-success"
            element={
              <Layout>
                <BeerStoreSuccess />
              </Layout>
            }
          />
          <Route
            path="/dashboard2"
            element={
              <DashboardLayout>
                <DashboardPage />
              </DashboardLayout>
            }
          />

          <Route path="/dashboard" element={<NewDashboardLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="subscription" element={<MySubscription />} />
          </Route>

          <Route path="/store" element={<StoreLayoutPage />} />
          <Route
            path="/mysubscription"
            element={
              <Layout>
                <MySubscription />
              </Layout>
            }
          />

          <Route
            path="/add-address"
            element={
              <Layout>
                <AddAddress />
              </Layout>
            }
          />
          <Route
            path="/addresses"
            element={
              <Layout>
                <MyAddresses />
              </Layout>
            }
          />

          <Route
            path="/beer-store"
            element={
              <Layout>
                <BeerStore />
              </Layout>
            }
          />
          <Route
            path="/beer-store/beer/:id"
            element={
              <Layout>
                <BeerDetail />
              </Layout>
            }
          />
          <Route
            path="/beer-store-shipping"
            element={
              <Layout>
                <BeerStoreShipping />
              </Layout>
            }
          />
          <Route
            path="/beer-store-payment"
            element={
              <Layout>
                <BeerStorePayment />
              </Layout>
            }
          />
          <Route
            path="/growlers"
            element={
              <Layout>
                <Growlers />
              </Layout>
            }
          />
          <Route
            path="/growlers/order-confirmation"
            element={
              <Layout>
                <GrowlerOrderConfirmation />
              </Layout>
            }
          />
          <Route
            path="/growlers/shipping"
            element={
              <Layout>
                <GrowlerShipping />
              </Layout>
            }
          />
          <Route
            path="/growlers/payment"
            element={
              <Layout>
                <GrowlerPayment />
              </Layout>
            }
          />
          <Route
            path="/growlers/success"
            element={
              <Layout>
                <GrowlerSuccess />
              </Layout>
            }
          />
          <Route
            path="/growlers/error"
            element={
              <Layout>
                <GrowlerError />
              </Layout>
            }
          />
          <Route
            path="/growlers/:id"
            element={
              <Layout>
                <GrowlerDetail />
              </Layout>
            }
          />
          <Route
            path="/my-account"
            element={
              <Layout>
                <MyAccount />
              </Layout>
            }
          />

          <Route
            path="/orders"
            element={
              <Layout>
                <MyOrders />
              </Layout>
            }
          />
          <Route
            path="/edit-name"
            element={
              <Layout>
                <EditName />
              </Layout>
            }
          />
          <Route
            path="/edit-password"
            element={
              <Layout>
                <EditPassword />
              </Layout>
            }
          />
          <Route
            path="/edit-phone"
            element={
              <Layout>
                <EditPhone />
              </Layout>
            }
          />
          <Route
            path="/order-confirmation"
            element={
              <Layout>
                <OrderConfirmation />
              </Layout>
            }
          />
          <Route
            path="/support"
            element={
              <Layout>
                <Support />
              </Layout>
            }
          />

          {/* <Route path="/signup" element={<SignUp />} />
        <Route path="/recovery" element={<RecoveryPassword />} /> */}
          {/* <Route
          path="/home"
          element={
            <ProtectedRoute>
            <Home />
            </ProtectedRoute>
            }
            /> */}
          {/* <Route
          path="/vouchers"
          element={
            <ProtectedRoute>
            <Vouchers />
            </ProtectedRoute>
            }
            />
            <Route
            path="/promotions"
            element={
              <ProtectedRoute>
              <Promotions />
              </ProtectedRoute>
              }
              />
              <Route
              path="/account"
              element={
                <ProtectedRoute>
                <Account />
                </ProtectedRoute>
                }
                /> */}
        </Routes>
      </ScrollToTop>
      </AgeVerificationGate>
    </Router>
  );
};

export default AppRoutes;
